import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import { createBrowserHistory } from 'history';
import { useEffect, useState } from 'react';
import Dashboard from '/views/Dashboard';
import Home from '/views/Home.jsx';
import Services from '/views/Services';
import ServiceTable from '/views/ServiceTable'
import Login from '/views/Login';
import Logout from '/views/Logout';
import Signup from '/views/Signup';
import Information from '/views/Information';
import CompanyHome from '/components/services/company/CompanyHome';
import CompanyList from '/components/services/company/CompanyList';
import CompanyAdd from '/components/services/company/CompanyAdd';
import CompanyUpdate from '/components/services/company/CompanyUpdate';
import CompanyDelete from '/components/services/company/CompanyDelete';
import UserHome from '/components/services/user/UserHome';
import UserList from '/components/services/user/UserList';
import UserAdd from '/components/services/user/UserAdd';
import UserUpdate from '/components/services/user/UserUpdate';
import UserDelete from '/components/services/user/UserDelete';

import { accountService } from '../../services/account/AccountService';

//const browserHistory = createBrowserHistory();

function AppRoutes() {

    // const browserHistory = createBrowserHistory();

    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(accountService.isAuthenticated());

    useEffect(() => {
        setIsAuthenticated(accountService.isAuthenticated());
    }, [location]);

    console.log(isAuthenticated)

    return <Routes>
    {/* <RouterRoutes history={browserHistory}> */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={isAuthenticated ? <Services /> : <Login />} />
        <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Login />} />
        <Route path="/servicetable" element={isAuthenticated ? <ServiceTable /> : <Login />} />
        <Route path="/login" element={isAuthenticated ? <Logout /> : <Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/information" element={<Information />} />
        <Route path="/companies" element={<CompanyHome />} />
        <Route path="/companieslist" element={<CompanyList />} />
        <Route path="/companiesadd" element={<CompanyAdd />} />
        <Route path="/companiesdelete" element={<CompanyDelete />} />
        <Route path="/companiesupdate" element={<CompanyUpdate />} />
        <Route path="/users" element={<UserHome />} />
        <Route path="/userslist" element={<UserList />} />
        <Route path="/usersadd" element={<UserAdd />} />
        <Route path="/usersdelete" element={<UserDelete />} />
        <Route path="/usersupdate" element={<UserUpdate />} />
    </Routes>
    {/* </RouterRoutes> */}
   

}

export default AppRoutes;